import { createContext, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { invokePostService } from "../../store/global/actions";

export const BottomDrawerContext = createContext();

export const BottomDrawerProvider = ({children}) => {
    const dispatch = useDispatch()
    const [activeTab, setActiveTab] = useState(0)
    const [tabConfig, setTabConfig] = useState(null)
    const [dockPosition, setDockPosition] = useState(localStorage.getItem('BOTTOM_DRAWER_DOCK') || 'bottom')
    const [leftPaneStatus, setLeftPaneStatus] = useState(localStorage.getItem('BOTTOM_DRAWER_LEFT_PANE') !== "collapsed")

    useMemo(() => {
        localStorage.setItem('BOTTOM_DRAWER_LEFT_PANE', leftPaneStatus ? "visible" : "collapsed")
    },[leftPaneStatus])

    useMemo(() => {
        dispatch(invokePostService('dockPosition', {dockPosition}))
    },[dockPosition])

    return (
        <BottomDrawerContext.Provider 
            value={{
                activeTab,
                setActiveTab,
                tabConfig,
                setTabConfig,
                dockPosition,
                setDockPosition,
                leftPaneStatus, 
                setLeftPaneStatus
            }}
        >
            {children}
        </BottomDrawerContext.Provider>
    )
}